export default function CTASection() {
  return (
    <section className="relative w-full min-h-[400px] md:min-h-[480px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20beautiful%20minimalist%20shopping%20scene%20with%20neatly%20arranged%20fashion%20items%20on%20a%20warm%20cream%20surface%2C%20soft%20natural%20window%20light%2C%20shopping%20bags%20sneakers%20and%20accessories%20in%20harmonious%20composition%2C%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20inviting%20and%20clean%20aesthetic&width=1600&height=700&seq=cta-bg-2026&orientation=landscape"
          alt="CSSBuy spreadsheet shopping ready to shop"
          className="w-full h-full object-cover object-center"
          title="CSSBuy Spreadsheet - Ready to Shop"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/45 via-black/30 to-black/15"></div>
      </div>

      <div className="relative w-full px-4 md:px-10 lg:px-16 z-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="max-w-xl">
            <h2 className="font-heading font-bold text-3xl md:text-5xl lg:text-6xl text-background-50 leading-none">
              ready to shop
            </h2>
            <p className="text-background-50/70 text-sm md:text-base mt-4 max-w-md leading-relaxed">
              One click away from exploring thousands of curated products across all categories. Your next great find is waiting on the CSSBuy spreadsheet.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-background-50 text-foreground-900 font-label font-bold text-sm rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer group shadow-lg"
            >
              buy it now
              <span className="w-6 h-6 flex items-center justify-center rounded-full bg-foreground-900 group-hover:bg-primary-500 transition-colors">
                <i className="ri-arrow-right-line text-xs text-background-50"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-background-50/15 backdrop-blur-sm border border-background-50/25 text-background-50 font-label font-semibold text-sm rounded-full hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer"
            >
              cssbuy sheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}